/** Clase que represent aun item de ejemplo */
export class ItemExampleDTO {

    //constructor de la clase
    constructor(

        /** Tipo de item */
        public tipoItem: string,

        /** Contenido del item */
        public contenidoItem: string

    ) { }
}
